import { useEffect, useState } from 'react';
import { generateRandomId } from 'utility/general';

const useMeasure = () => {
    const [uid] = useState(generateRandomId());

    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        let observer = new ResizeObserver(function (mutations) {
            const target = document.querySelector(`.${uid}`);

            if (target) {
                setSize({
                    width: target.offsetWidth,
                    height: target.offsetHeight,
                });
            }
        });

        let child = document.querySelector(`.${uid}`);
        observer.observe(child, { attributes: true });

        return () => {
            observer.disconnect();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [uid, size];
};

export default useMeasure;
